var map = {
	"./0357c5dd845c6c292e80e5f3dd8013c5.jpg": "0c76",
	"./1ced75e15b7bb5b5a8be9f2dfd4f5822.jpg": "4182",
	"./212f65ddb94ae562d8e90b98ab5941b0.jpg": "0c24",
	"./3442f0794cde4ae9023d26e9d8be0de1.jpg": "51b3",
	"./393562264d663d5050116504e4fa475b.jpg": "eb00",
	"./4373f2417bd94a4cad13d6bb0e07cb49.jpg": "1409",
	"./461169d29a3f0ca35491194cb09b4d56.jpg": "d543",
	"./4c015da7403efe2a23f5f04a88610721.jpg": "bcb8",
	"./5e2d121d7b032776a5a35e4019033e0f.jpg": "e41d",
	"./98a2e06848a6fe9b27c6a71cde847d31.jpg": "8204",
	"./A.png": "0099",
	"./Mask Group 1.png": "03ea",
	"./Mask Group 26.png": "d29f",
	"./Mask Group 3.png": "0d0e",
	"./MaskGroup2.png": "c6f3",
	"./No-Image-Placeholder-banner.svg": "a38b",
	"./No-Image-Placeholder.svg.png": "51b2",
	"./Rectangle 1586.svg": "5363",
	"./Rectangle.svg": "2135",
	"./a7e7880bef7a4e67e4ecb227be4d7940.jpg": "d847",
	"./buy2get1.webp": "1061",
	"./buy3kabove2000off.webp": "40a7",
	"./c2.png": "5f2a",
	"./c3.png": "8d8a",
	"./c4.png": "975a",
	"./c5.png": "04d9",
	"./c6.png": "e0e9",
	"./c7.png": "7b9f",
	"./c8.png": "6e7c",
	"./email.svg": "4a49",
	"./emptyCart.png": "b8f9",
	"./f9c470559374134d8ee7bf8d825de527.jpg": "8437",
	"./facebook.svg": "2a17",
	"./fee4f8dee45ac1b3825a996f8ed52667.jpg": "c633",
	"./istockphoto-1246562124-612x612.jpg": "e697",
	"./linkdin.svg": "3906",
	"./linkedin.svg": "3013",
	"./logBG.png": "0fa9",
	"./nextbg.png": "c675",
	"./nextw.png": "8945",
	"./noProfileImg.jpg": "39d9",
	"./noimage.png": "5bab",
	"./orchid.avif": "3559",
	"./orchid.jpg": "8434",
	"./orchid2.jpg": "b014",
	"./orchid3.jpg": "c8c9",
	"./outofstock.jpg": "3677",
	"./outofstock.png": "7973",
	"./outofstock1.png": "1e23",
	"./phone.svg": "2611",
	"./plant.jpg": "f955",
	"./plant2.jpg": "f5a1",
	"./plant3.jpg": "e510",
	"./pp.jpg": "3598",
	"./prev.png": "8630",
	"./prevw.png": "8c25",
	"./s1.jpg": "8ee8",
	"./spice1.webp": "36eb",
	"./spices.jpg": "91ce",
	"./twitter.svg": "2879",
	"./waterlilly.jpg": "5758",
	"./waterlilly2.jpg": "0193",
	"./waterlilly3.jpg": "6477"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d25";